import { LocalDataError } from '../types.js';
import { qtyFromMilli, rateFromBp } from './totals.js';
export async function tillContext(driver, offers) {
    const rows = await driver.query({
        sql: `SELECT timezone, packaging_takeaway_paise, packaging_delivery_paise, delivery_fee_paise,
                 service_charge_pct_bp
          FROM property LIMIT 1`,
    });
    const row = rows[0];
    if (!row) {
        throw new LocalDataError('PROPERTY_NOT_PROVISIONED', 'The property profile has not been provisioned on this device');
    }
    const charges = {
        packagingTakeaway: Number(row.packaging_takeaway_paise ?? 0),
        packagingDelivery: Number(row.packaging_delivery_paise ?? 0),
        deliveryFee: Number(row.delivery_fee_paise ?? 0),
        serviceChargePct: rateFromBp(Number(row.service_charge_pct_bp ?? 0)),
    };
    return {
        charges,
        offers: await offers.listActive(),
        timeZone: row.timezone == null ? 'Asia/Kolkata' : String(row.timezone),
    };
}
/**
 * Order lines shaped for `applyOffers()` - a live join against `menu_items`
 * for categoryId, matching the server's own non-snapshotted join
 * (`orderInclude.lines.include.menuItem.select.categoryId`,
 * apps/api/src/modules/pos/service.ts): an offer scoped to a category must
 * see today's category, not whatever it was when the line was rung up.
 */
export async function linesForOffers(driver, lines) {
    if (lines.length === 0)
        return [];
    const placeholders = lines.map(() => '?').join(',');
    const rows = await driver.query({
        sql: `SELECT id, category_id FROM menu_items WHERE id IN (${placeholders})`,
        params: lines.map((l) => l.menuItemId),
    });
    const categoryById = new Map(rows.map((r) => [String(r.id), r.category_id == null ? null : String(r.category_id)]));
    return lines.map((line) => ({
        menuItemId: line.menuItemId,
        categoryId: categoryById.get(line.menuItemId) ?? null,
        name: line.name,
        unitPrice: line.unitPricePaise,
        quantity: qtyFromMilli(line.quantityMilli),
    }));
}
//# sourceMappingURL=till.js.map